import type { FieldMissionHeader } from '@groupe-reca/contracts'
import { useEffect, useState } from 'react'
import { formatDuration } from '../../domain/fieldText'
import { missionActiveSeconds } from '../missionClock'

// Carte « Mission » du panneau gauche (maquette « Disposition Mission v2 ») : route, opérateur, équipement,
// progression et durée de la SORTIE. Ce n'est pas le temps de travail d'une résidence (carte Résidence).

const tickMs = 30_000

/**
 * Horloge isolée : son minuteur ne redessine que ce texte, jamais la carte ni le panneau. Remontée à chaque relecture
 * du serveur (clé) : en pause elle affiche la valeur lue, sans défiler.
 */
function MissionClock({ mission }: { mission: FieldMissionHeader }) {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    if (mission.pausedAt) return
    const timer = setInterval(() => {
      setNow(new Date())
    }, tickMs)
    return () => {
      clearInterval(timer)
    }
  }, [mission.pausedAt])
  return <>{formatDuration(missionActiveSeconds(mission, now))}</>
}

export function MissionCard({ mission }: { mission: FieldMissionHeader }) {
  const { completed, total, problem, waiting } = mission.progress
  const percent = total > 0 ? Math.round((completed / total) * 100) : 0
  return (
    <section className="op-mission-card" aria-label="Mission">
      <div className="op-mission-card__row">
        <div className="op-mission-card__ids">
          <span className="op-mission-card__route">
            <span className="op-swatch" style={{ background: mission.routeColor ?? undefined }} aria-hidden="true" />
            {mission.routeName ?? 'Route —'}
          </span>
          <strong>{mission.operatorName ?? 'Opérateur —'}</strong>
          <span>{mission.equipmentLabel ?? 'Équipement —'}</span>
        </div>
        <div className="op-mission-card__count" aria-live="polite">
          <strong>
            {completed}
            <span>/{total}</span>
          </strong>
          <span>terminées</span>
        </div>
      </div>
      <div
        className="op-mission-card__bar"
        role="progressbar"
        aria-label="Progression de la mission"
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={completed}
      >
        <span style={{ width: `${String(percent)}%` }} />
      </div>
      <dl className="op-mission-card__stats">
        <div>
          <dt>Restantes</dt>
          <dd>{waiting}</dd>
        </div>
        <div className={problem > 0 ? 'is-problem' : undefined}>
          <dt>Problèmes</dt>
          <dd>{problem}</dd>
        </div>
        <div>
          <dt>Durée de mission</dt>
          <dd>
            <MissionClock key={`${mission.status}:${String(mission.pausedSeconds)}`} mission={mission} />
          </dd>
        </div>
      </dl>
    </section>
  )
}
